import http from "../axios/http-common";
import {
  RencanaKontrolListParams,
  RencanaKontrolListResponse,
  RencanaKontrolSyncResponse
} from "@/types/rencanaKontrol";

async function getList(
  params: RencanaKontrolListParams
): Promise<RencanaKontrolListResponse> {
  const resp = await http.getDataParam("/rencana-kontrol", { params });

  return resp.data;
}

async function syncSrk(id: number): Promise<RencanaKontrolSyncResponse> {
  const resp = await http.postData(`/rencana-kontrol/${id}/sync`, {});

  return resp.data;
}

export default { getList, syncSrk };
